import { api_configuration } from "../../common";
import api_app = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.application.alan_api;
import api_cs = api_configuration.types.client_state.alan_api;
import * as expressions from "../state/expressions";
import * as Status from "../Status";
import { onScalarValue } from "../../../../../stream";

export function initializedStyle(style: api_cs.Cstyle): api_cs.Cyes__initialized__style {
	switch (style.properties.initialized.state.name) {
		case "no": {
			style.properties.initialized.set("yes", {
				"has style": "no",
			});
			return style.properties.initialized.cast("yes");
		}
		case "yes": {
			const $ = style.properties.initialized.state.node;
			return $;
		}
		default:
			unexpectedState(style.properties.initialized.state);
	}
}

type SubscribedStyle = {
	__style_subscribed: boolean;
};
export function evaluateStyle(
	style: api_cs.Cyes__initialized__style,
	expression: api_app.Cui_expression,
	this_node: api_cs.Cnode
): void {
	const subscribed_style = style as unknown as SubscribedStyle;
	if (subscribed_style.__style_subscribed) {
		return;
	}
	subscribed_style.__style_subscribed = true;
	onScalarValue(
		expressions.ui_expression<expressions.Style>(expression)([this_node, null]),
		(value) => {
			if (style.destroyed) return;
			if (Status.isResolved(value)) {
				style.properties.has_style.set("yes", {
					type: value,
				});
			} else {
				style.properties.has_style.ensure("no", {});
			}
		},
		(scalar, subscription) => style.properties.has_style.onDestroy(() => scalar.unsubscribe(subscription))
	);
}

export function unsetStyle(style: api_cs.Cyes__initialized__style): void {
	const subscribed_style = style as unknown as SubscribedStyle;
	subscribed_style.__style_subscribed = false;
	style.properties.has_style.ensure("no", {});
}

export function hasStyle(state_group: api_app.Cstate_group): boolean {
	let has_state_styles = false;
	state_group.properties.states.forEach((state) => {
		has_state_styles = has_state_styles || state.properties.ui.properties.has_style.state.name === "yes";
	});
	return has_state_styles;
}
